import { render, staticRenderFns } from "./ReportSelector.vue?vue&type=template&id=2b37b73e"
import script from "./ReportSelector.vue?vue&type=script&lang=js"
export * from "./ReportSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b37b73e')) {
      api.createRecord('2b37b73e', component.options)
    } else {
      api.reload('2b37b73e', component.options)
    }
    module.hot.accept("./ReportSelector.vue?vue&type=template&id=2b37b73e", function () {
      api.rerender('2b37b73e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/ReportSelector.vue"
export default component.exports